<div class="overflow-hidden mvh95">
  <ul class="list-unstyled d-flex flex-column gap-1rem">
    @for(dado of dadosNotificacoes; track dado) {
      <li>
        <app-notificacao-chat 
          (fecharComponentEmitter)="fecharNotificacao($event)"  
          [dadosNotificacao]="dado" 
          [indexNotificacao]="$index">
        </app-notificacao-chat>
      </li>
    }
  </ul>
</div>
